/* import __COLOCATED_TEMPLATE__ from './pull-zendesk-data.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import templateOnlyComponent from '@ember/component/template-only';
import type { PulseAccordion } from 'glint/pulse';

export interface Args {
  onContinue: () => void;
  accordion: PulseAccordion;
}

const PullZendeskData = templateOnlyComponent<Args>();
export default PullZendeskData;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Zendesk::Deploy::Common::PullZendeskData': typeof PullZendeskData;
    'standalone/zendesk/deploy/common/pull-zendesk-data': typeof PullZendeskData;
  }
}
